import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Button from "../../components/button";
import TextField from "../../components/textField/textField";
import { useSafeNavigate } from "../../components/unloadBlocker";
import { useAppContext } from "../../context/appContext";
import { sha256 } from "../../utils/passwordUtils";
import LoginBox from "./loginBox";

interface LoginPageProps {
    registeSuccess?: boolean;
}

export default function LoginPage(props: LoginPageProps) {

    const {setUserData, accountController} = useAppContext();

    const navigate = useSafeNavigate(useNavigate());
    
    const [error, setError] = useState<string | undefined>(undefined);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    async function login() {
        setIsLoading(true);
        setError(undefined);
        if(email.trim() == "" || password.trim() == "") {
            setError("Please fill out all fields.");
            setIsLoading(false);
            return;
        }
        console.log("logging in");
        await accountController.login({
            email: email,
            password: await sha256(password)
        }).then(response => {
            setUserData(response.data);
            navigate("/dashboard/mypieces");
        }).catch(error => {
            if(error.response && error.response.data && error.response.data.message) {
                setError(error.response.data.message);
            }else {
                setError("An unknown error occurred.");
            }
            if(error.status == 403 && error.response.data.details) {
                navigate("/signup/verifyEmail/" + error.response.data.details);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }

    return <LoginBox title={props.registeSuccess ? "Successfully registered!" : undefined} login bottom={
        <p>Problems login in? <a href="mailto:info@txoria.org">Contact us</a></p>
        
    }>
        <Helmet>
            <title>Login | Txoria</title>
        </Helmet>
        <TextField type="email" autoFocus placeholder="Email..." label="Email" value={email} onChange={setEmail}/>
        <TextField showPasswordEye onEnter={login} placeholder="Password..." label="Password" value={password} onChange={setPassword} type="password"/>
        <p className="error">{error}</p>
        <Button loading={isLoading} onClick={login}>Log In</Button>

    </LoginBox>
}